module.exports = __webpack_public_path__ + "img/cross-icon.05edc0b2.svg";